import React, { useEffect, useState } from "react";
import { ActivityTracker } from "cai-fusion";
import { useNewTemplate } from "../../contexts/NewTemplateContext";

const LoadingTemplateActivityTracker = ({isHidden}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { chatTemplates, chatTemplateId } = useNewTemplate();

    useEffect(() => {
        if (!isHidden) {
            setIsCollapsed(false);
        }
    }, [isHidden])

    return (
        <ActivityTracker
            message={`Loading ${`"${(chatTemplates.find((template) => template.id === chatTemplateId))?.title}"` ?? "your template"}...`}
            isHidden={isHidden}
            isCollapsed={isCollapsed}
            onCollapse={(collapseState) => setIsCollapsed(collapseState)}
            hideProgressBar
        />
    )
}

export default LoadingTemplateActivityTracker;